import { Theme } from '@mui/material'
import { Components } from '@mui/material/styles/components'

export const C1LinearProgressTheme: Components<Theme>['MuiLinearProgress'] = {
    styleOverrides: {
        root: ({ theme }) =>
            theme.unstable_sx({
                height: '7px', // Half of font size. TODO santhosh Move to rems
                borderRadius: '7px',
                backgroundColor: 'grey.200',
            }),
        bar1Determinate: ({ ownerState, theme }) =>
            theme.unstable_sx({
                ...(ownerState.color === 'warning' && {
                    backgroundColor: 'warning.main',
                }),
            }),
    },
}
